import { render } from "./BaseViewBtn.vue?vue&type=template&id=0dbda96a"
import script from "./BaseViewBtn.vue?vue&type=script&lang=js"
export * from "./BaseViewBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__